module.exports = __webpack_public_path__ + "img/x.117aa414.svg";